(() => {
  const overrides = [
    {
      source: 'coffee_corner.png',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-main-grid-coffee-corner-lifestyle-square-01.webp?v=1786780022',
      alt: 'PegGrid Main Grid organised as a coffee corner with espresso equipment, bags, shoes and green storage crates.'
    },
    {
      source: 'ChatGPT_Image_2026_3_18_12_35_21.png',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-single-pegboard-hook-product-render-square-01.webp?v=1786780028',
      alt: 'Black PegGrid single pegboard hook product render on a white background.'
    },
    {
      source: 'Accessories_Cover_img.jpg',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-accessories-snowboard-storage-banner-landscape-01.webp?v=1786780035',
      alt: 'Snowboard and bindings stored on a black PegGrid accessories wall.'
    },
    {
      source: 'outdoor_set_cover.jpg',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-essential-set-outdoor-gear-banner-landscape-01.webp?v=1786780043',
      alt: 'PegGrid Essential Set organised with camping equipment, outdoor gear, shelves and storage cases.'
    },
    {
      source: 'Extension_Grid.jpg',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-extension-grid-product-render-square-01.webp?v=1786780050',
      alt: 'Black PegGrid Extension Grid product render with perforated panels and base.'
    },
    {
      source: '47.png',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-adjustable-ski-snowboard-rack-product-render-square-01.webp?v=1786780057',
      alt: 'Black PegGrid adjustable ski and snowboard rack with six timber support pegs.'
    },
    {
      source: '25.png',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-clothes-rail-rack-product-render-square-01.webp?v=1786780063',
      alt: 'Black PegGrid clothes rail rack with adjustable mounting brackets.'
    },
    {
      source: '42.png',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-dual-short-pegboard-hook-product-render-square-01.webp?v=1786780070',
      alt: 'Black PegGrid dual short pegboard hook product render on a white background.'
    },
    {
      source: '39.png',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-dual-long-pegboard-hook-product-render-square-01.webp?v=1786780077',
      alt: 'Black PegGrid dual long pegboard hook product render on a white background.'
    },
    {
      source: '44.png',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-double-curved-pegboard-hook-product-render-square-01.webp?v=1786780084',
      alt: 'Black PegGrid double curved pegboard hook product render on a white background.'
    },
    {
      source: '37.png',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-mini-shelf-panel-product-render-square-01.webp?v=1786780091',
      alt: 'Black PegGrid mini shelf panel product render on a white background.'
    },
    {
      source: '13.jpg',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-motion-sensor-led-light-bar-product-render-square-01.webp?v=1786780098',
      alt: 'Black PegGrid motion sensor LED light bar product render on a white background.'
    },
    {
      source: '28.png',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-shelf-product-render-square-01.webp?v=1786780105',
      alt: 'Black PegGrid shelf product render with a concealed mounting bracket.'
    },
    {
      source: 'Shelf_x_1.png',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-storage-basket-product-render-square-01.webp?v=1786780112',
      alt: 'Black wire PegGrid storage basket product render on a white background.'
    }
  ];

  const widths = [320, 480, 640, 800, 1000, 1200, 1600, 2048, 2400];
  const imageAttributes = ['src', 'srcset', 'data-src', 'data-srcset', 'data-original'];

  const valueFor = (element) => {
    const values = imageAttributes.map((attribute) => element.getAttribute(attribute) || '');
    if (element.currentSrc) values.push(element.currentSrc);
    return values.join(' ');
  };

  const findOverride = (value) => overrides.find((item) => value.includes(item.source));

  const urlAtWidth = (url, width) => {
    const next = new URL(url);
    next.searchParams.set('width', String(width));
    return next.toString();
  };

  const srcsetFor = (url) => widths.map((width) => `${urlAtWidth(url, width)} ${width}w`).join(', ');

  const applyImageOverride = (image) => {
    if (!(image instanceof HTMLImageElement)) return;

    const isEssentialSetDesktopCard =
      image.closest('.pg-custom-card-media--desktop') &&
      image.closest('a[href*="/products/peggrid-essential-set"]');
    if (isEssentialSetDesktopCard) return;

    const override = findOverride(valueFor(image));
    if (!override) return;
    if (image.dataset.peggridP0Override === override.source) return;

    const responsiveSrcset = srcsetFor(override.url);
    image.src = override.url;
    image.srcset = responsiveSrcset;
    image.alt = override.alt;
    image.dataset.peggridP0Override = override.source;

    ['data-src', 'data-original'].forEach((attribute) => {
      if (image.hasAttribute(attribute)) image.setAttribute(attribute, override.url);
    });
    if (image.hasAttribute('data-srcset')) image.setAttribute('data-srcset', responsiveSrcset);

    const picture = image.closest('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach((source) => {
        source.srcset = responsiveSrcset;
        if (source.hasAttribute('data-srcset')) source.setAttribute('data-srcset', responsiveSrcset);
      });
    }
  };

  const applyBackgroundOverride = (element) => {
    if (!(element instanceof HTMLElement)) return;
    const inlineStyle = element.getAttribute('style') || '';
    const override = findOverride(inlineStyle);
    if (!override) return;
    element.style.backgroundImage = `url("${override.url}")`;
    element.setAttribute('role', element.getAttribute('role') || 'img');
    element.setAttribute('aria-label', override.alt);
  };

  const applyWithin = (root) => {
    if (root instanceof HTMLImageElement) applyImageOverride(root);
    if (root instanceof HTMLElement) applyBackgroundOverride(root);
    if (!(root instanceof Element || root instanceof Document)) return;
    root.querySelectorAll('img').forEach(applyImageOverride);
    root.querySelectorAll('[style*="url("]').forEach(applyBackgroundOverride);
  };

  const start = () => {
    applyWithin(document);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') applyWithin(mutation.target);
        mutation.addedNodes.forEach((node) => applyWithin(node));
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: imageAttributes.concat('style')
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
